import { render } from "./Navi.vue?vue&type=template&id=94e785e2&ts=true"
import script from "./Navi.vue?vue&type=script&lang=ts"
export * from "./Navi.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__